import { Button, Group, Modal, Select, Space, TextInput } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconFilter, IconFilterCancel } from "@tabler/icons-react";
import { ChangeEvent, useCallback, useState } from "react";

export interface FiltroDesafio {
  search: string;
  campo: string;
  status: string;
}

const mockFilter: FiltroDesafio = {
  search: "",
  campo: "",
  status: ""
};

const camposDisponiveis = ["Título", "Autor(es)", "E-mail"];

const statusDisponiveis = [
  { value: "", label: "Todos os status" },
  { value: "DRAFT", label: "Rascunho" },
  { value: "NOVO_DESAFIO", label: "Novo Desafio" },
  { value: "PROPOSTO_PELO_COLABORADOR", label: "Proposto pelo Colaborador" },
  { value: "PRE_ANALISE", label: "Pré-análise" },
  { value: "ANALISE_DE_VIABILIDADE", label: "Análise de Viabilidade" },
  { value: "AGUARDANDO_ANALISE_DO_COMITE", label: "Aguardando Análise do Comitê" },
  { value: "APROVADO_PELO_COMITE", label: "Aprovado pelo Comitê" },
  { value: "AGENDADO", label: "Agendado" },
  { value: "RECUSADO_PELO_COMITE", label: "Recusado pelo Comitê" },
  { value: "BACKLOG_PARA_AVALIACAO_FUTURA", label: "Backlog para Avaliação Futura" },
  { value: "EM_REALIZACAO", label: "Em Realização" },
  { value: "REALIZADO", label: "Realizado" },
  { value: "SOLUCOES_VALIDADAS", label: "Soluções Validadas" },
  { value: "CANCELADA", label: "Cancelada" }
];

interface ModalFilterDesafiosProperties {
  setFilter: React.Dispatch<React.SetStateAction<FiltroDesafio>>;
}

const ModalFilterDesafios = ({ setFilter }: ModalFilterDesafiosProperties) => {
  const [opened, { open, close }] = useDisclosure(false);
  const [values, setValues] = useState<FiltroDesafio>(mockFilter);

  const clearFiltro = useCallback(() => {
    setFilter(mockFilter);
    setValues(mockFilter);
  }, [setFilter]);

  const applyFilter = useCallback(() => {
    setFilter(values);
    setValues(mockFilter);
    close();
  }, [setFilter, close, values]);

  const changeInput = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setValues((values) => ({ ...values, search: event.target.value }));
  }, []);

  const changeCampo = useCallback((campo: string | null) => {
    setValues((values) => ({ ...values, campo: campo || "" }));
  }, []);

  const changeStatus = useCallback((status: string | null) => {
    setValues((values) => ({ ...values, status: status || "" }));
  }, []);

  return (
    <>
      <Button variant="transparent" p="0px">
        <IconFilter onClick={open} />
      </Button>
      <Button variant="transparent" onClick={clearFiltro} p="0px">
        <IconFilterCancel />
      </Button>

      <Modal opened={opened} onClose={close} title="Filtrar Desafios">
        <Select
          label="Campo a ser filtrado"
          placeholder="Selecione um campo..."
          data={camposDisponiveis}
          value={values.campo}
          onChange={changeCampo}
          clearable
        />

        <Space h="md" />

        <TextInput
          label="Texto a ser procurado"
          placeholder="Digite o texto para buscar..."
          value={values.search}
          onChange={changeInput}
        />

        <Space h="md" />

        <Select
          label="Status do desafio"
          placeholder="Selecione um status..."
          data={statusDisponiveis}
          value={values.status}
          onChange={changeStatus}
          clearable
        />

        <Space h="xl" />

        <Group justify="flex-end">
          <Button variant="transparent" onClick={close}>
            Cancelar
          </Button>
          <Button variant="filled" onClick={applyFilter}>
            Filtrar
          </Button>
        </Group>
      </Modal>
    </>
  );
};

export default ModalFilterDesafios;
